import { render } from "./ArgonInput.vue?vue&type=template&id=ce89ff36"
import script from "./ArgonInput.vue?vue&type=script&lang=js"
export * from "./ArgonInput.vue?vue&type=script&lang=js"

import "./ArgonInput.vue?vue&type=style&index=0&id=ce89ff36&lang=css"

import exportComponent from "/home/thales/Projetos/aceite-eletronico/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__